import {
  ERROR_CIRCUITS_BY_CUSTOMER_ID,
  ERROR_CIRCUITS_BY_USER_ID,
  LOADING_CIRCUITS_BY_CUSTOMER_ID,
  LOADING_CIRCUITS_BY_USER_ID,
  SUCCESS_CIRCUITS_BY_CUSTOMER_ID,
  SUCCESS_CIRCUITS_BY_USER_ID,
} from "../../const/actionTypes";
import { BASE_URL } from "../../const/URL";
import { ICustomerCircuit } from "../../interfaces/customerCircuid";
import { EPackageType } from "../../interfaces/packageType";
import axiosInstance from "../../services/axiosInstance";
import hasRequestError from "../../util/hasRequestError";

export const getCircuitsByCustomerID = (customerId: number) => {
  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_CIRCUITS_BY_CUSTOMER_ID);
    axiosInstance
      .get(`${BASE_URL}/api/v1/circuits/customer/${customerId}`)
      .then((response) => {
        if (hasRequestError(response)) {
          throw new Error(response.data.message);
        }

        const payload = response.data.dataBundle as ICustomerCircuit[];
        let packageTypes = payload.map((item) => item.packageType);
        packageTypes = packageTypes.filter((item, pos) => {
          return packageTypes.indexOf(item) === pos;
        });

        dispatchAction(dispatch, SUCCESS_CIRCUITS_BY_CUSTOMER_ID, {
          data: payload,
          packageTypes,
        });
      })
      .catch((error) => {
        dispatchAction(dispatch, ERROR_CIRCUITS_BY_CUSTOMER_ID, error.message);
      });
  };
};
export const getCircuitsByUserID = (userId: number | undefined) => {
  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_CIRCUITS_BY_USER_ID);
    axiosInstance
      .get(`${BASE_URL}/api/v1/circuits/users/${userId}/dashboard`)
      .then((response) => {
        if (hasRequestError(response)) {
          throw new Error(response.data.message);
        }

        const payload = response.data.dataBundle as ICustomerCircuit[];
        let packageTypes = payload.map((item) => item.packageType);
        packageTypes = packageTypes.filter((item, pos) => {
          return packageTypes.indexOf(item) === pos;
        });

        dispatchAction(dispatch, SUCCESS_CIRCUITS_BY_USER_ID, {
          data: payload,
          packageTypes,
        });
      })
      .catch((error) => {
        dispatchAction(dispatch, ERROR_CIRCUITS_BY_USER_ID, error.message);
      });
  };
};

export const getCircuitsByUserIDV2 = async (userId: number | undefined) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/api/v1/circuits/users/${userId}/dashboard`
    );

    if (hasRequestError(response)) {
      throw new Error(response.data.message);
    }

    const payload = response.data.dataBundle as ICustomerCircuit[];

    // Filter circuits where packageType is "Broadband"
    const broadbandCircuits = payload.filter(
      (item) => item.packageType === EPackageType.BROADBAND
    );

    // Extract circuitId and groupNickName
    const circuitDetails = broadbandCircuits.map((item) => ({
      circuitId: item.circuitId,
      groupNickName: item.circuitNickName,
    }));

    // Return the filtered data
    return {
      data: broadbandCircuits,
      packageTypes: Array.from(
        new Set(payload.map((item) => item.packageType))
      ),
      broadbandCircuits: circuitDetails,
    };
  } catch (error) {
    throw new Error(
      error instanceof Error ? error.message : "Failed to fetch circuits"
    );
  }
};

const dispatchAction = (dispatch: any, type: string, payload?: {}) => {
  dispatch({
    type: type,
    payload: payload,
  });
};
